<template>
  <div class="project-settings-auto-forwarding-email">
    <i class="ddi ddi-auto-forwarding" />
    <clipboard-text
      :id="`project-email-alias-${id}`"
      :text="email"
      suppress-styles
      class="project-settings-auto-forwarding-email__title"
    />
    <div>
      <dd-icon-button
        :is-disabled="disabled"
        danger
        icon="trash"
        type="rounded"
        size="medium"
        color="grey"
        title="Remove this forwarding address"
        @click="remove"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjectSettingsAutoForwardingEmail',

  props: {
    id: {
      type: Number,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['remove'],
  methods: {
    remove(): void {
      this.$emit('remove', this.id)
    },
  },
})
</script>

<style lang="scss" scoped>
.project-settings-auto-forwarding-email {
  display: flex;
  align-items: center;
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: $border--solid-extra-light;
  }

  > i {
    color: var(--color-text-third);
  }

  &__title {
    margin-left: 10px;
    @include lettering--p;
    font-weight: $bold;
    word-break: break-all;
  }

  > div {
    display: flex;
    margin-left: auto;
    padding-left: 10px;
  }
}
</style>
